import o from "./index60.mjs";
import i from "./index62.mjs";
function f(t) {
  var r = i(t, "string");
  return o(r) == "symbol" ? r : r + "";
}
export {
  f as default
};
